// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.gds.GraphicalClientRequestContext
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { AbstractClientRequestContext } from "abweb/dto/ds/AbstractClientRequestContext";
import { HistoricalPointInTime } from "abweb/dto/ds/HistoricalPointInTime";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class GraphicalClientRequestContextBase extends AbstractClientRequestContext {
  /** Do NOT invoke directly, instead use strongly typed createGraphicalClientRequestContextBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadg.GraphicalClientRequestContext";
  }
  initFromJson(json, deserializeContext) {
    this.initGraphicalClientRequestContext(TSOGUtils.decodeObject(json.historicalPointInTime, HistoricalPointInTime, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "historicalPointInTime")), json.collapsedNodes != null ? json.collapsedNodes : null, json.expandedNodes != null ? json.expandedNodes : null, json.exposedNodes != null ? json.exposedNodes : null, json.filterDownstream != null ? json.filterDownstream : null, json.filterUpstream != null ? json.filterUpstream : null, json.hiddenNodes != null ? json.hiddenNodes : null, json.refreshExpression != null ? json.refreshExpression : null, json.refreshInterval, json.walkedNodes != null ? json.walkedNodes : null);
  }
  initGraphicalClientRequestContext(historicalPointInTime, collapsedNodes, expandedNodes, exposedNodes, filterDownstream, filterUpstream, hiddenNodes, refreshExpression, refreshInterval, walkedNodes) {
    this.initAbstractClientRequestContext(historicalPointInTime);
    this._collapsedNodes = collapsedNodes;
    this._expandedNodes = expandedNodes;
    this._exposedNodes = exposedNodes;
    this._filterDownstream = filterDownstream;
    this._filterUpstream = filterUpstream;
    this._hiddenNodes = hiddenNodes;
    this._refreshExpression = refreshExpression;
    this._refreshInterval = refreshInterval;
    this._walkedNodes = walkedNodes;
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    retVal["collapsedNodes"] = this._collapsedNodes;
    retVal["expandedNodes"] = this._expandedNodes;
    retVal["exposedNodes"] = this._exposedNodes;
    retVal["filterDownstream"] = this._filterDownstream;
    retVal["filterUpstream"] = this._filterUpstream;
    retVal["hiddenNodes"] = this._hiddenNodes;
    retVal["refreshExpression"] = this._refreshExpression;
    retVal["refreshInterval"] = this._refreshInterval;
    retVal["walkedNodes"] = this._walkedNodes;
    return retVal;
  }
  get collapsedNodes() {
    return this._collapsedNodes;
  }
  set collapsedNodes(value) {
    this._collapsedNodes = value;
  }
  get expandedNodes() {
    return this._expandedNodes;
  }
  set expandedNodes(value) {
    this._expandedNodes = value;
  }
  get exposedNodes() {
    return this._exposedNodes;
  }
  set exposedNodes(value) {
    this._exposedNodes = value;
  }
  get filterDownstream() {
    return this._filterDownstream;
  }
  set filterDownstream(value) {
    this._filterDownstream = value;
  }
  get filterUpstream() {
    return this._filterUpstream;
  }
  set filterUpstream(value) {
    this._filterUpstream = value;
  }
  get hiddenNodes() {
    return this._hiddenNodes;
  }
  set hiddenNodes(value) {
    this._hiddenNodes = value;
  }
  get refreshExpression() {
    return this._refreshExpression;
  }
  set refreshExpression(value) {
    this._refreshExpression = value;
  }
  get refreshInterval() {
    return this._refreshInterval;
  }
  set refreshInterval(value) {
    this._refreshInterval = value;
  }
  get walkedNodes() {
    return this._walkedNodes;
  }
  set walkedNodes(value) {
    this._walkedNodes = value;
  }
}
//# sourceMappingURL=GraphicalClientRequestContextBase.js.map
